import { Button, Modal } from "antd";
import SuccessIcon from "@/assets/images/success.png";
import { useCountDown } from "ahooks";

const Countdown = ({ onFinish }: { onFinish: () => void }) => {
  const [, { seconds }] = useCountDown({
    leftTime: 3000,
    onEnd() {
      onFinish();
    },
  });

  return seconds;
};

type PaySuccessModalProps = {
  open: boolean;
  onClose: () => void;
};
export default function PaySuccessModal(props: PaySuccessModalProps) {
  const { open, onClose } = props;

  return (
    <Modal
      open={open}
      footer={null}
      maskClosable={false}
      closable={false}
      width={320}
      centered
      destroyOnClose
    >
      <div className="mb-6 flex justify-center mt-6">
        <img src={SuccessIcon} width={48} />
      </div>
      <div className="text-center font-bold text-base text-text-strong mb-9">
        支付成功
      </div>
      <div className="text-center">
        <Button type="primary" onClick={onClose} className="mb-6">
          <Countdown onFinish={onClose} />
          秒后收起
        </Button>
      </div>
    </Modal>
  );
}
